import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1
  }
}));

interface NumberFormatCustomProps {
  inputRef: (instance: HTMLInputElement | null) => void;
  onChange: (event: { target: { value: string } }) => void;
  name: string;
}

const NumberFormatCustom = (props: NumberFormatCustomProps) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({ target: { value: values.value } });
      }}
      thousandSeparator
      isNumericString
      suffix="€"
    />
  );
}

interface SelectAmountProps {
  default: string;
  onAmountChange: (amount: string) => void;
}

export const SelectAmount = (props: SelectAmountProps) => {
  const classes = useStyles();
  const [amount, setAmount] = useState<string>(props.default);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAmount(event.target.value);
    props.onAmountChange(event.target.value);
  };

  return (
    <div className={classes.container}>
      <TextField
        id="formatted-numberformat-input"
        label="Montant du chèque"
        value={amount}
        onChange={handleChange}
        InputProps={{
          inputComponent: NumberFormatCustom as any
        }}
      />
    </div>
  );
}
